import HeaderComponent from "src/Components/Header";
import FooterComponent from "src/Components/Footer";
import BookingLayout from "src/Layouts/Booking";

const BookingPage = () => {
  return (
    <>
      <div className="min-h-full">
        <HeaderComponent />
        <main>
          <div className="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">
            <BookingLayout />
          </div>
        </main>
        <FooterComponent />
      </div>
    </>
  );
};

export default BookingPage;
